var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThird(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 50,
    viewBox: "0 0 42.43 42.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #305549;\n      }\n\n      .cls-3 {\n        isolation: isolate;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    className: "cls-1",
    cx: 21.21,
    cy: 21.21,
    r: 21.21
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.59,13.14c1.13-.99,2.67-1.49,4.6-1.49,1.29,0,2.39,.22,3.3,.67,.92,.45,1.61,1.05,2.08,1.83,.47,.77,.71,1.64,.71,2.6,0,1.13-.28,2.05-.85,2.76-.57,.71-1.23,1.2-1.98,1.45v.1c.98,.33,1.75,.87,2.31,1.62,.57,.75,.85,1.72,.85,2.91,0,1.06-.24,2-.73,2.82-.49,.81-1.2,1.45-2.13,1.92-.93,.46-2.04,.69-3.33,.69-2.06,0-3.7-.5-4.92-1.52-1.23-1.01-1.87-2.54-1.94-4.58h4.27c.02,.75,.23,1.35,.64,1.79,.41,.44,1.01,.66,1.8,.66,.67,0,1.19-.19,1.56-.58,.37-.39,.55-.9,.55-1.53,0-.82-.26-1.42-.78-1.79-.52-.37-1.36-.55-2.51-.55h-.82v-3.57h.82c.87,0,1.58-.15,2.12-.45,.54-.3,.81-.84,.81-1.61,0-.62-.17-1.1-.51-1.44-.34-.34-.81-.51-1.41-.51-.65,0-1.14,.2-1.45,.59-.32,.39-.5,.88-.55,1.47h-4.29c.07-1.83,.67-3.25,1.8-4.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.81,18.72h-5.8c.04,.52,.21,.92,.5,1.19,.29,.28,.66,.41,1.09,.41,.64,0,1.08-.27,1.33-.81h2.73c-.14,.55-.39,1.04-.76,1.48-.37,.44-.82,.79-1.37,1.04-.55,.25-1.16,.38-1.84,.38-.82,0-1.55-.18-2.19-.53-.64-.35-1.14-.85-1.5-1.5s-.54-1.41-.54-2.28,.18-1.63,.53-2.28c.35-.65,.85-1.15,1.49-1.5,.64-.35,1.38-.53,2.21-.53s1.53,.17,2.16,.51,1.12,.82,1.48,1.46c.36,.63,.53,1.36,.53,2.2,0,.24-.01,.49-.04,.75Zm-2.58-1.42c0-.44-.15-.79-.45-1.05-.3-.26-.67-.39-1.12-.39s-.79,.12-1.09,.38-.48,.6-.55,1.06h3.21Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThird);
export default __webpack_public_path__ + "static/media/third.fbfe3a23e6cd2a60073f93abaa95e0a7.svg";
export { ForwardRef as ReactComponent };